import { STATIC_DOMAINS } from "@/mk/settings";

export default process.env.NODE_ENV === "test"
    ? `https://mkskasmodrykonik.vshcdn.net/` // Hack that we are all using custom asset url in DEV
    : `https://${STATIC_DOMAINS.asset[0]}/`;
